import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/consulting.css';
import './styles/premium.css';
import './styles/homepage-redesign.css';

// Layout
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProposalDevelopmentPage from './pages/services/ProposalDevelopmentPage';
import CaptureSupportPage from './pages/services/CaptureSupportPage';
import ProposalManagementPage from './pages/services/ProposalManagementPage';
import ProposalDesignPage from './pages/services/ProposalDesignPage';
import ProcessPage from './pages/ProcessPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import FreeAssessmentPage from './pages/FreeAssessmentPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/proposal-development" element={<ProposalDevelopmentPage />} />
          <Route path="/services/capture-support" element={<CaptureSupportPage />} />
          <Route path="/services/proposal-management" element={<ProposalManagementPage />} />
          <Route path="/services/proposal-design" element={<ProposalDesignPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/free-assessment" element={<FreeAssessmentPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
